import { useMutation, useQueryClient } from 'react-query'
import { useAuth0 } from '../../contexts/auth0-context'
import callAPI from '../../API/callSecureAPI'
import endpoints from '../../API/endpoints'

type UseApproveKESMutationProps = {
    onSuccess?: () => void
    onError?: (error: unknown) => void
}

type ApproveKESVariables = {
    id: string
    payload?: Record<string, unknown>
}

export const useApproveKESMutation = ({ onSuccess, onError }: UseApproveKESMutationProps = {}) => {
    const { getTokenSilently, isAuthenticated } = useAuth0()
    const queryClient = useQueryClient()

    const approveKES = async ({ id, payload }: ApproveKESVariables) => {
        if (!isAuthenticated) throw new Error('User must be authenticated to approve a KES')

        const token = await getTokenSilently?.({ audience: 'https://atlas.aesara.com' })
        if (!token) throw new Error('Failed to get authentication token')

        const response = await callAPI(endpoints.updateKES.url + id, endpoints.updateKES.method, token, {
            status: 'approved',
            ...payload,
        })

        if (!response.success) throw new Error(response.error || 'Failed to approve KES')

        return response
    }

    return useMutation(approveKES, {
        onSuccess: () => {
            queryClient.invalidateQueries(['draftKES'])
            onSuccess?.()
        },
        onError: (error) => {
            console.error('Error approving KES:', error)
            onError?.(error)
        },
    })
}
